import CartCosts from './CartCosts';
import DiscountForm from './DiscountForm';
import { CartPaymentSectionProps } from './types';

const CartPaymentSection: React.FC<CartPaymentSectionProps> = ({
  discounts,
  onApplyDiscountCode,
  onRemoveDiscountCode,
  isEmpty,
  className,
  button,
}) => {
  return (
    <div className={className}>
      {!isEmpty && (
        <DiscountForm
          discounts={discounts}
          onApplyDiscountCode={onApplyDiscountCode}
          onRemoveDiscountCode={onRemoveDiscountCode}
        />
      )}

      <div className="border-t border-neutral-400 bg-white pt-2">
        <CartCosts />
        {button}
      </div>
    </div>
  );
};

export default CartPaymentSection;
